// extracted by mini-css-extract-plugin
export default {"wrapper":"DeviceModal_wrapper__eay6S","tips":"DeviceModal_tips__CzpFJ","red":"DeviceModal_red__EKhve"};